module.exports = __webpack_public_path__ + "static/media/cogs.76d2a72a.svg";